import { ClusterSelect } from './ClusterSelect';

import { RffSwitch } from '@cast/shared-rff-ui';

import { Typography, Box, Stack, tokens } from '@cast/design-system';

export const ClustersSection = () => {
  return (
    <Stack gap="16px">
      <ClusterSelect />
      <Box
        sx={{
          border: '1px solid',
          borderColor: tokens.theme.border.structural.neutral,
          borderRadius: '4px',
          p: '12px 16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 8,
        }}
      >
        <Stack gap={2}>
          <Typography variant="P12M">Include non-cluster alerts</Typography>
          <Typography variant="P12R" color="textSecondary">
            Include alerts that are not associated with any specific cluster
          </Typography>
        </Stack>
        <RffSwitch
          size="md"
          name="includeClusterless"
          testId="include-clusterless-switch"
        />
      </Box>
    </Stack>
  );
};
